import React, { useEffect, useRef } from 'react';
import './AutocompleteDropdown.css';

const AutocompleteDropdown = ({ 
  suggestions, 
  onSelect, 
  selectedIndex, 
  position,
  onClose 
}) => {
  const dropdownRef = useRef(null);
  const selectedItemRef = useRef(null);

  // Scroll selected item into view
  useEffect(() => {
    if (selectedItemRef.current && selectedIndex >= 0 && selectedItemRef.current.scrollIntoView) {
      selectedItemRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  }, [selectedIndex]);

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  // Handle clicks outside dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  const visibleSuggestions = suggestions.slice(0, 4);
  const hasMoreSuggestions = suggestions.length > 4;

  return (
    <div 
      ref={dropdownRef}
      className="autocompleteDropdown" 
      style={position}
    >
      <div className="suggestionsList">
        {suggestions.map((suggestion, index) => (
          <div 
            key={suggestion}
            ref={index === selectedIndex ? selectedItemRef : null}
            className={`suggestionItem ${index === selectedIndex ? 'selected' : ''}`}
            onClick={() => onSelect(suggestion)}
            onMouseEnter={() => {
              // Optional: could add hover selection here if needed
            }}
          >
            {suggestion}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AutocompleteDropdown;